import { createFragmentContainer, graphql } from 'react-relay';
import App from './AppComponent';
// import AvailabilityCheckerContainer from '../Modules/AvailabilityChecker/AvailabilityCheckerContainer';
// import AvailabilityCalendarContainer from '../Modules/AvailabilityCalendar/AvailabilityCalendarContainer';

export default createFragmentContainer(App, {
  viewer: graphql`
    fragment AppContainer_viewer on User {
      id
      first_name
      last_name
      s_time_zone
      ...AvailabilityCheckerContainer_viewer
    }
  `,
});



// WEBPACK FOOTER //
// ./webpack/components/App/AppContainer.js